class AboutTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this);
    this.addEventListener('keydown', this);
    this.addEventListener('scroll', this, { capture: true, passive: true });
    window.addEventListener('resize', this);
    this.updateArrows();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this);
  }

  get tabs() {
    return [...this.querySelectorAll('[role="tab"]')];
  }

  get activeRail() {
    return [...this.querySelectorAll('.about-rail')].find((rail) => !rail.closest('[hidden]'));
  }

  handleEvent(event) {
    if (event.type === 'click') this.handleClick(event);
    else if (event.type === 'keydown') this.handleKeydown(event);
    else this.updateArrows();
  }

  handleClick({ target }) {
    const tab = target.closest('[role="tab"]');
    if (tab) return this.select(tab);

    const arrow = target.closest('[data-rail-direction]');
    if (arrow) this.moveRail(this.activeRail, Number(arrow.dataset.railDirection));
  }

  handleKeydown(event) {
    const { key, target } = event;
    if (target.matches('.about-rail') && ['ArrowLeft', 'ArrowRight'].includes(key)) {
      event.preventDefault();
      return this.moveRail(target, key === 'ArrowRight' ? 1 : -1);
    }

    const tabs = this.tabs;
    const index = tabs.indexOf(target);
    if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

    event.preventDefault();
    const steps = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: tabs.length - 1 };
    this.select(tabs[(steps[key] + tabs.length) % tabs.length], true);
  }

  select(selected, focus = false) {
    for (const tab of this.tabs) {
      const isActive = tab === selected;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !isActive;
    }
    if (focus) selected.focus({ preventScroll: true });
    requestAnimationFrame(() => this.updateArrows());
  }

  moveRail(rail, direction) {
    if (!rail) return;
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = (rail.firstElementChild?.offsetWidth ?? rail.clientWidth) + gap;
    rail.scrollBy({ left: step * direction });
  }

  updateArrows() {
    const rail = this.activeRail;
    if (!rail) return;
    const max = rail.scrollWidth - rail.clientWidth;
    for (const arrow of this.querySelectorAll('[data-rail-direction]')) {
      arrow.disabled = Number(arrow.dataset.railDirection) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
    }
  }
}

if (!customElements.get('about-tabs')) customElements.define('about-tabs', AboutTabs);
